import axios from 'axios';

import {isPlatform} from "@ionic/vue";
import config from "@/config";

const namespaced = true

const state = {
    posts: [],
    fetchActive: true
}

const actions = {
    async getAll({dispatch}) {
        return await dispatch('database/getItems', {table: 'news'}, {root: true})
    },
    async fetchFromHttp({dispatch}, id) {
        let posts = (await axios.get('https://mantel-api.mobile.documedias.systems/v2/conferences/' + id + '/news')).data;
        await dispatch('database/upsertItems', {items: posts, table: 'news'}, {root: true});
        return posts;
    },

    async checkAllowedToSee({rootState}, post) {
        let user = rootState.auth.user;
        let conf = rootState.currentConference.currentConference;

        let isIos = 'true'; //isPlatform('ios');
        let isAndroid = isPlatform('android');

        let userPlatform = null
        let userAppVersion = null;
        if (isIos) {
            userPlatform = 'ios';
            userAppVersion = config.versionIOS
        }
        if (isAndroid) {
            userPlatform = 'android';
            userAppVersion = config.versionAndroid
        }
        console.log('fetch news', post.extra.filters, isIos, isAndroid)

        let allowed = false;
        if (!post.extra.filters) {
            allowed = true
        } else {
            let filterCount = 0;
            for (const [key, value] of Object.entries(post.extra.filters)) {
                filterCount += value.length;
                //TODO:hier weiter prüfen
                if (key == 'users' && value.length > 0) {
                    let users = value.split(',');
                    allowed = users.indexOf(user.id +'') > -1
                }
                if (key == 'platforms' && value.length > 0) {
                    if (value.indexOf(userPlatform) > -1) {
                        allowed = true;
                    }
                }
                if (key == 'versions' && value.length > 0) {
                    if (value.indexOf(userAppVersion) > -1) {
                        allowed = true;
                    }
                }


            }
            if (filterCount == 0) {
                allowed = true
            }
        }
        return allowed;
    },


    async fetchNews({dispatch, state, rootState}, id) {
        try {
            let _posts = (await dispatch('fetchFromHttp', id)).sort((a, b) => {
                return new Date(b.publish_at) - new Date(a.publish_at);
            });
            state.posts = [];
            let oldTime = await dispatch('personalDB/getItem', 'timeStamps_' + rootState.currentConference.currentConference, {root: true});
            let time = await dispatch('personalDB/setTime', {
                name: 'timeStamps_' + rootState.currentConference.currentConference,
                item: oldTime
            }, {root: true});
            for (let i = 0; i < _posts.length; i++) {
                let post = _posts[i];
                post.publish_at = post.publish_at.indexOf('Z') === -1 ? new Date(post.publish_at + '+00:00') : new Date(post.publish_at);
                if ((new Date(post.publish_at)) < (new Date())) {
                    post.unread = (new Date(post.publish_at)) > time;
                    if (JSON.stringify(state.posts).indexOf(post.id) == -1) {
                        //TODO:check for user filter
                        if (await dispatch('checkAllowedToSee', post)) {
                            state.posts.push(post);
                        }
                    }
                }
            }

            state.fetchActive = false;
        } catch (err) {
            console.log('EERRORR', err)
            try {
                let _posts = (await dispatch('getAll')).sort((a, b) => {
                    return new Date(b.publish_at) - new Date(a.publish_at);
                });

                let oldTime = await dispatch('personalDB/getItem', 'timeStamps_' + rootState.currentConference.currentConference, {root: true});
                let time = await dispatch('personalDB/setTime', {
                    name: 'timeStamps_' + rootState.currentConference.currentConference,
                    item: oldTime
                }, {root: true});
                for (let i = 0; i < _posts.length; i++) {
                    let post = _posts[i];
                    post.publish_at = post.publish_at.indexOf('Z') === -1 ? new Date(post.publish_at + '+00:00') : new Date(post.publish_at);
                    if ((new Date(post.publish_at)) < (new Date())) {
                        post.unread = (new Date(post.publish_at)) > time;
                        if (JSON.stringify(state.posts).indexOf(post.id) == -1) {

                            //TODO:check for user filter
                            if (await dispatch('checkAllowedToSee', post)) {
                                state.posts.push(post);
                            }
                        }
                    }
                }

                state.fetchActive = false;
            } catch (err) {
                state.posts;
            }
        }
    },

    getNewsNumber() {
        return state.newsNumber;
    }
}
const mutations = {
    addNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber + state.newsNumber;
    },
    resetNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber;
    }
}
const getters = {}

export const news = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
